var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBarcode = function SvgIconBarcode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.875 4.875a1 1 0 0 1 1-1h3.75a1 1 0 0 1 1 1v3.75a1 1 0 1 1-2 0v-2.75h-2.75a1 1 0 0 1-1-1M3.375 14.375a1 1 0 0 1 1 1v2.75h2.75a1 1 0 1 1 0 2h-3.75a1 1 0 0 1-1-1v-3.75a1 1 0 0 1 1-1M21.625 15.375a1 1 0 1 0-2 0v2.75h-2.75a1 1 0 1 0 0 2h3.75a1 1 0 0 0 1-1zM2.375 4.875a1 1 0 0 1 1-1h3.75a1 1 0 0 1 0 2h-2.75v2.75a1 1 0 0 1-2 0zM9.25 8.625a1 1 0 0 0-2 0v6.75a1 1 0 1 0 2 0zM15.75 7.625a1 1 0 0 1 1 1v6.75a1 1 0 1 1-2 0v-6.75a1 1 0 0 1 1-1M13 8.625a1 1 0 1 0-2 0v6.75a1 1 0 1 0 2 0z"
  }))));
};
export default SvgIconBarcode;